// project imports
import { ThemeMode } from '@/theme/config';
import { PalettesProps } from '@ant-design/colors';
import { PaletteThemeProps } from '@/theme/types/theme';
import { PresetColor } from '@/theme/types/config';
import Default from './default';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

// presetColor este fix 'default' (ConfigContext nu expune schimbarea lui) — paletele
// theme1–theme8 din Mantis au fost eliminate ca dead code.
export default function Theme(
	colors: PalettesProps,
	_presetColor: PresetColor,
	_mode: ThemeMode
): PaletteThemeProps {
	return Default(colors);
}
